export default {
  getIncomeLine: (state) => state.incomeLine,
  incomeLines: (state) => state.incomeLines,
};
